import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';

function Setari() {
  const [dateUtilizator, setDateUtilizator] = useState({
    nume: '',
    email: '',
    telefon: ''
  });
  const [parolaCurenta, setParolaCurenta] = useState('');
  const [parolaNoua, setParolaNoua] = useState('');
  const [incarca, setIncarca] = useState(true);
  const [salveaza, setSalveaza] = useState(false);
  const navigate = useNavigate();

  const taburi = [
    { nume: 'Gestioneaza anunturile', link: '/anunturile-mele', activ: false },
    { nume: 'Comenzile mele', link: '/comenzi', activ: false },
    { nume: 'Mesaje', link: '/mesaje', activ: false },
    { nume: 'Favorite', link: '/favorite', activ: false },
    { nume: 'Alertele mele', link: '/alerte', activ: false },
    { nume: 'Detaliile mele', link: '/setari', activ: true }
  ];

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/');
      return;
    }
    incarcaDateProfil(token);
  }, [navigate]);

  const incarcaDateProfil = async (token) => {
    try {
      const raspuns = await fetch('https://tranzitio.onrender.com/api/autentificare/me', {
        headers: { 'x-auth-token': token }
      });
      const date = await raspuns.json();
      
      if (raspuns.ok) {
        setDateUtilizator({
          nume: date.nume || '',
          email: date.email || '',
          telefon: date.telefon || ''
        });
      } else {
        toast.error('Eroare la incarcarea datelor');
      }
    } catch (eroare) {
      toast.error('Eroare de conexiune la server');
    } finally {
      setIncarca(false);
    }
  };

  const handleSchimbare = (e) => {
    setDateUtilizator({ ...dateUtilizator, [e.target.name]: e.target.value });
  };

  const salveazaDatele = async (e) => {
    e.preventDefault();
    if (parolaNoua && !parolaCurenta) {
      toast.error('Introdu parola actuala pentru a salva una noua.');
      return;
    }

    setSalveaza(true);
    const token = localStorage.getItem('token');

    try {
      const raspuns = await fetch('https://tranzitio.onrender.com/api/autentificare/actualizare', {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'x-auth-token': token
        },
        body: JSON.stringify({
          ...dateUtilizator,
          parolaCurenta: parolaCurenta ? parolaCurenta : undefined,
          parolaNoua: parolaNoua ? parolaNoua : undefined
        })
      });

      const rezultat = await raspuns.json();

      if (raspuns.ok) {
        toast.success(rezultat.mesaj);
        setParolaCurenta('');
        setParolaNoua('');
        
        const utilizatorCurent = JSON.parse(localStorage.getItem('utilizator') || '{}');
        localStorage.setItem('utilizator', JSON.stringify({ ...utilizatorCurent, nume: dateUtilizator.nume }));
        window.dispatchEvent(new Event('storage'));
      } else {
        toast.error(rezultat.mesaj);
      }
    } catch (eroare) {
      toast.error('Eroare de conexiune');
    } finally {
      setSalveaza(false);
    }
  };

  if (incarca) {
    return <div className="text-center mt-20 font-bold text-xl text-gray-500">Se incarca...</div>;
  }

  return (
    <div className="min-h-screen bg-[#f3f4f6]">
      <div className="bg-white border-b border-gray-200 overflow-x-auto">
        <div className="max-w-7xl mx-auto px-4 flex min-w-max">
          {taburi.map((tab, index) => (
            <Link
              key={index}
              to={tab.link}
              className={`flex items-center gap-2 px-6 py-4 text-sm font-bold transition-all border-b-4 ${
                tab.activ 
                  ? 'border-blue-600 text-blue-700' 
                  : 'border-transparent text-gray-500 hover:text-gray-800 hover:bg-gray-50'
              }`}
            >
              {tab.nume}
            </Link>
          ))}
        </div>
      </div>

      <div className="max-w-3xl mx-auto px-4 py-8">
        <h2 className="text-2xl font-black text-gray-800 mb-6">Detaliile mele</h2>
        
        <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-8">
          <form onSubmit={salveazaDatele} className="space-y-6">
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className="block text-sm font-bold text-gray-700 mb-2">Nume complet</label>
                <input
                  type="text"
                  name="nume"
                  value={dateUtilizator.nume}
                  onChange={handleSchimbare}
                  required
                  className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:outline-none focus:border-blue-600 focus:ring-1 focus:ring-blue-600 bg-gray-50 focus:bg-white transition-colors"
                />
              </div>

              <div>
                <label className="block text-sm font-bold text-gray-700 mb-2">Adresa de email</label>
                <input
                  type="email"
                  name="email"
                  value={dateUtilizator.email}
                  onChange={handleSchimbare}
                  required
                  className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:outline-none focus:border-blue-600 focus:ring-1 focus:ring-blue-600 bg-gray-50 focus:bg-white transition-colors"
                />
              </div>
            </div>

            <div>
              <label className="block text-sm font-bold text-gray-700 mb-2">Numar de telefon</label>
              <input
                type="text"
                name="telefon"
                value={dateUtilizator.telefon}
                onChange={handleSchimbare}
                className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:outline-none focus:border-blue-600 focus:ring-1 focus:ring-blue-600 bg-gray-50 focus:bg-white transition-colors"
                placeholder="Ex: 0722123456"
              />
            </div>

            <hr className="border-gray-100 my-8" />
            
            <div>
              <h3 className="text-lg font-bold text-gray-800 mb-4">Securitate Parola</h3>
              <p className="text-sm text-gray-500 mb-4">Completeaza aceste campuri doar daca doresti sa schimbi parola curenta.</p>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-sm font-bold text-gray-700 mb-2">Parola actuala</label>
                  <input
                    type="password"
                    value={parolaCurenta}
                    onChange={(e) => setParolaCurenta(e.target.value)}
                    className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:outline-none focus:border-blue-600 focus:ring-1 focus:ring-blue-600 bg-gray-50 focus:bg-white transition-colors"
                    placeholder="Introdu parola curenta"
                  />
                </div>
                
                <div>
                  <label className="block text-sm font-bold text-gray-700 mb-2">Noua parola</label>
                  <input
                    type="password"
                    value={parolaNoua}
                    onChange={(e) => setParolaNoua(e.target.value)}
                    className="w-full border border-gray-300 rounded-lg px-4 py-3 focus:outline-none focus:border-blue-600 focus:ring-1 focus:ring-blue-600 bg-gray-50 focus:bg-white transition-colors"
                    placeholder="Minim 6 caractere"
                  />
                </div>
              </div>
            </div>

            <div className="pt-4 flex justify-end">
              <button
                type="submit"
                disabled={salveaza}
                className="bg-blue-600 text-white font-bold px-8 py-3.5 rounded-xl hover:bg-blue-700 shadow-md hover:shadow-lg transition-all flex items-center gap-2"
              >
                {salveaza ? (
                  <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                ) : (
                  <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                )}
                Salveaza modificarile
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Setari;